import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ForcedLogoutService } from '../../services/forced-logout.service';

export interface CanComponentDeactivate {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  private forcedLogoutService = inject(ForcedLogoutService);

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    if (this.forcedLogoutService.isForcedLogout()) {
      return true;
    }

    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
